import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9zh7wytr9: FaireProductEntity = {
  token: "p_g9zh7wytr9",
  type: "product",
  name: "Porcelain Trinket Dish | Caviar",
  brandToken: "b_11db373e",
  brandName: "Idlewild Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/d6ba30241255f1d5a34a7283c85fd0cb7aa30dacc259df687ba0e2e6747ddede.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69ceab71d4bb28cec942d93cc10429943d52f18832f13667ca17869b917c4866.jpeg",
    "https://cdn.faire.com/fastly/f20e1ccc20aa807113a64f7e910ff75eaa4a07405e3a557853ba32470d6bc54c.jpeg",
  ],
  priceDollars: 11,
  description:
    "A fan favorite giftable–Our ceramic trinket dishes are the perfect catchall for your nightstand or dresser. White porcelain is adorned with our colorful, hand-painted designs, and we lined the edge in 10k gold for added flair. Perfectly packaged in plastic-free gift boxes, pretty enough to give without wrapping!\n\n• Round Dish: 3.5″\n• Ceramic with 10k Gold Detailing\n• Plastic-Free Gift Box\n• Food-Safe | Hand Wash Only\n\n\n\n\n\nKeywords for SEO:\nTrinket Dish, Dish, Ring Dish, Ceramic, Porcelain, Gold, Idlewild Co., Idlewild, Accessory, Gift, Stocking Stuffer, Jewelry Dish, Jewelry Box, Nature, chef, foodie, kitchen, cook, oysters, gourmet, caviar, osetra,  beluga, vodka, roe, blini, crème fraîche, delicacy, shellfish, summer, home decor, vintage, display, earring display, displays for retail, gift idea, wedding, ceramics, engagement gift, jewelry displays, necklace display, ring dish, trinket box, mahjong, mahjong accessories, dice dish, dice dishes, new england gifts, new england, summer gifts, coastal decor, spring, fall, winter, holidy gifts",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:08.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
